import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import TuiSelect from '../Select';
import TuiOption from '../Option';
interface Props {
  modelValue: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TimepickerPC',
  props: {
    modelValue: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: string;
};



const selectedTime = ref(props.modelValue);

const timeOptions = computed(() => {
  const options = [];
  for (let i = 0; i < 24; i++) {
    for (let j = 0; j < 60; j += 15) {
      const hour = i < 10 ? `0${i}` : `${i}`;
      const minute = j < 10 ? `0${j}` : `${j}`;
      options.push(`${hour}:${minute}`);
    }
  }
  return options;
});

const updateTime = () => {
  emit('input', selectedTime.value);
};

watch(
  selectedTime,
  () => {
    updateTime();
  },
  {
    immediate: true,
  }
);
watch(
  () => props.modelValue,
  newValue => {
    selectedTime.value = newValue;
  },
  { immediate: true }
);

return { __sfc: true,props, emit, selectedTime, timeOptions, updateTime, TuiSelect, TuiOption }
}

})